import React from 'react'
import {
  createWorkoutExerciseAction,
  updateCurrentWorkoutSectionAction,
  getParentIdWorkoutUtil
} from '@gymaholic/packages'
import getIdReduxUtil from 'modules/redux/utils/get-id'

export const useExerciseWorkout = ({
  exercise,
  exerciseId,
  isReadOnly,
  isReplacing,
  currentWorkout,
  currentWorkoutSection,
  location,
  loading,
  setLoading,
  handleNavigateToOrigin,
  dispatch
}) => {
  React.useEffect(() => {
    if (
      !isReadOnly &&
      exercise &&
      !isReplacing
    ) {
      dispatch(
        createWorkoutExerciseAction({ exerciseId })
      )
    }
  }, [exercise])

  React.useEffect(() => {
    if (
      !isReadOnly &&
      currentWorkout &&
      !currentWorkoutSection &&
      location.state
    ) {
      dispatch(
        updateCurrentWorkoutSectionAction(location.state.workoutSectionId)
      )
    }
  }, [currentWorkout])

  React.useEffect(() => {
    const parentId = getParentIdWorkoutUtil(currentWorkout)
    const workoutId = getIdReduxUtil(currentWorkout)

    if (parentId && workoutId > 0 && loading) {
      setLoading(false)
      handleNavigateToOrigin(workoutId)
    }
  }, [currentWorkout])
}
